import { TransactionFilter } from '../models/transactions';
import { LocationFilter } from '../models/locations';
import { UserOrgFilter } from "~/apps/shared/models";


// Transaction filters
export function parseTransactionFilter(params: any): TransactionFilter {
  return {
    q: params.q,
    locationId: params.locationId,
  };
}

export function transactionFilterParams(filter: TransactionFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }

    if (filter.locationId) {
      qs.locationId = filter.locationId;
    }
  }

  return qs;
}

// Location filters
export function parseLocationFilter(params: any): LocationFilter {
  return {
    q: params.q,
  };
}

export function locationFilterParams(filter: LocationFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}

// Users organisation
export function getUserOrgFilter(params: any): UserOrgFilter {
  return {
    q: params.q,
  };
}


export function userOrgFilter(filter: UserOrgFilter): any {
  const qs: any = {};

  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}

export function addUserOrgFilter(qs: any, filter: UserOrgFilter): any {
  if (filter) {
    if (filter.q) {
      qs.q = filter.q;
    }
  }

  return qs;
}
